import { render, staticRenderFns } from "./SvgAssets.vue?vue&type=template&id=a11cf108"
import script from "./SvgAssets.vue?vue&type=script&lang=js"
export * from "./SvgAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports